import objectUtils from '../utils/object-utils'

export default class Order {
  constructor (options = {}) {
    this.model = 'Order'

    // Test Order
    this.is_test = options.is_test === true

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.order_number = objectUtils.get(options, 'order_number', null)
    this.tracking_number = objectUtils.get(options, 'tracking_number', null)
    this.name = objectUtils.get(options, 'name', null)

    // Third-party references
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)
    this.thirdparty_order_id = objectUtils.get(options, 'thirdparty_order_id', null) // use for provider API calls !!!
    this.thirdparty_order_number = objectUtils.get(options, 'thirdparty_order_number', null)
    this.thirdparty_account_id = objectUtils.get(options, 'thirdparty_account_id', null)
    this.thirdparty_account_name = objectUtils.get(options, 'thirdparty_account_name', null)
    this.thirdparty_brand_id = (options.thirdparty_brand_id && options.thirdparty_brand_id !== 'null') ? options.thirdparty_brand_id : null
    this.thirdparty_brand_name = objectUtils.get(options, 'thirdparty_brand_name', null)
    this.thirdparty_invoice_id = (options.thirdparty_invoice_id && options.thirdparty_invoice_id !== 'null') ? options.thirdparty_invoice_id : null
    this.thirdparty_notes = objectUtils.get(options, 'thirdparty_notes', null)
    this.brand_image_src = objectUtils.get(options, 'brand_image_src', null)

    // Order details
    this.is_credit = options.is_credit
    this.shipper_id = objectUtils.get(options, 'shipper_id', null)
    this.receiver_id = objectUtils.get(options, 'receiver_id', null)
    this.product_classification = objectUtils.get(options, 'product_classification', null)
    this.total_weight_in_grams = objectUtils.get(options, 'total_weight_in_grams', null)
    this.total_weight_in_grams_validated = objectUtils.get(options, 'total_weight_in_grams_validated', null)
    this.order_status = objectUtils.get(options, 'order_status', null)
    this.payment_status = objectUtils.get(options, 'payment_status', null)
    this.expected_delivery = objectUtils.get(options, 'expected_delivery', null)
    this.scheduled_delivery = objectUtils.get(options, 'scheduled_delivery', null)
    this.estimated_shipper_arrival_time = objectUtils.get(options, 'estimated_shipper_arrival_time', null)
    this.estimated_receiver_arrival_time = objectUtils.get(options, 'estimated_receiver_arrival_time', null)
    this.route_id = objectUtils.get(options, 'route_id', null)
    this.appointment_confirmed = objectUtils.get(options, 'appointment_confirmed', false)

    // RouteLeaf delivery info
    this.shipper_notes = objectUtils.get(options, 'shipper_notes', null)
    this.receiver_notes = objectUtils.get(options, 'receiver_notes', null)
    this.delivery_info = options.delivery_info || {}
    this.dispatcher_notes = options.dispatcher_notes || {}
    this.driver_notes = options.driver_notes || {}

    // RouteLeaf order history trail (for rejected or rescheduled orders)
    this.root_order_id = objectUtils.get(options, 'root_order_id', null)
    this.parent_order_id = objectUtils.get(options, 'parent_order_id', null)

    // Uploaded document info
    this.supporting_docs = objectUtils.get(options, 'supporting_docs', null)
    this.attachment_docs = objectUtils.get(options, 'attachment_docs', null)
    this.is_data_ready = options.is_data_ready

    // Workflow tracking
    this.placed_at = objectUtils.get(options, 'placed_at', null)
    this.appointment_confirmed_at = objectUtils.get(options, 'appointment_confirmed_at', null)
    this.scheduled_at = objectUtils.get(options, 'scheduled_at', null)
    this.to_shipper_at = objectUtils.get(options, 'to_shipper_at', null)
    this.at_shipper_at = objectUtils.get(options, 'at_shipper_at', null)
    this.code_confirmed_at = objectUtils.get(options, 'code_confirmed_at', null)
    this.items_checked_at = objectUtils.get(options, 'items_checked_at', null)
    this.driver_pickup_signed_at = objectUtils.get(options, 'driver_pickup_signed_at', null)
    this.picked_up_at = objectUtils.get(options, 'picked_up_at', null)
    this.to_receiver_at = objectUtils.get(options, 'to_receiver_at', null)
    this.at_receiver_at = objectUtils.get(options, 'at_receiver_at', null)
    this.driver_deliver_signed_at = objectUtils.get(options, 'driver_deliver_signed_at', null)
    this.receiver_card_saved_at = objectUtils.get(options, 'receiver_card_saved_at', null)
    this.receiver_signed_at = objectUtils.get(options, 'receiver_signed_at', null)
    this.delivered_at = objectUtils.get(options, 'delivered_at', null)
    this.rescheduled_at = objectUtils.get(options, 'rescheduled_at', null)
    this.rejected_at = objectUtils.get(options, 'rejected_at', null)
    this.canceled_at = objectUtils.get(options, 'canceled_at', null)
    this.completed_at = objectUtils.get(options, 'completed_at', null)

    // Receiving agent info
    this.receiving_agent_id = objectUtils.get(options, 'receiving_agent_id', null)
    this.receiving_agent_name = objectUtils.get(options, 'receiving_agent_name', null)
    this.receiving_agent_signature_url = objectUtils.get(options, 'receiving_agent_signature_url', null)
    this.receiving_agent_fa_license_number = objectUtils.get(options, 'receiving_agent_fa_license_number', null)
    this.receiving_agent_fa_license_expiration = objectUtils.get(options, 'receiving_agent_fa_license_expiration', null)

    // Auditing
    this.submitted_by = objectUtils.get(options, 'submitted_by', null)
    this.purchased_by = objectUtils.get(options, 'purchased_by', null)
    this.scheduled_by = objectUtils.get(options, 'scheduled_by', null)
    this.rescheduled_by = objectUtils.get(options, 'rescheduled_by', null)
    this.rejected_by = objectUtils.get(options, 'rejected_by', null)

    // Associations
    if (options.route_info) this.route_info = options.route_info
    if (options.root_order) this.root_order = options.root_order
    if (options.parent_order) this.parent_order = options.parent_order
    if (options.order_details) this.order_details = options.order_details
    if (options.shipper) this.shipper = options.shipper
    if (options.receiver) this.receiver = options.receiver
    if (options.submitter) this.submitter = options.submitter
    if (options.dispatcher) this.dispatcher = options.dispatcher
  }
}
